import { useState } from "react";
import { Link, withRouter } from "react-router-dom";

import { useTranslation } from "react-i18next";
import FeedbackLogs from "../../components/Communications/Feedback/FeedbackLogs";
import InstructionsList from "../../components/Communications/InstructionsList";

const Communications = ({ history }) => {
  const { t } = useTranslation();
  const tabs = ["Feedback", "Instructions"];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  return (
    <div>
      <div className="container pt-4">
        <h4 className="text-brand">
          <Link to="/">
            <i
              className="fas fa-arrow-left link"
              style={{ cursor: "pointer" }}
            />
          </Link>
          &nbsp;&nbsp;{t("Communications")}
        </h4>{" "}
        <div className="d-flex text-center border-bottom">
          {tabs.map((tab, index) => (
            <div
              key={index}
              className={`col-6 py-3 flex-grow-1 ${
                activeTab === tab ? "font-weight-bold text-brand" : "text-muted"
              }`}
              style={
                activeTab === tab ? { borderBottom: "3px solid #466ea5" } : {}
              }
              onClick={() => setActiveTab(tab)}
            >
              {t(tab)}
            </div>
          ))}
        </div>
        {activeTab === "Feedback" && <FeedbackLogs />}
        {activeTab === "Instructions" && <InstructionsList />}
      </div>
    </div>
  );
};

export default withRouter(Communications);
